var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    staticStyle: {
      "margin-left": "20%"
    },
    attrs: {
      "label-width": "80px",
      model: _vm.form,
      "label-position": "left"
    }
  }, [_c("p", {
    staticStyle: {
      color: "#FF5050",
      "font-size": "12px"
    }
  }, [_vm._v("备注：以下所有内容必填")]), _c("el-form-item", {
    attrs: {
      label: "申请原因",
      "label-width": "150px"
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.reason,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "reason", $$v);
      },
      expression: "form.reason"
    }
  })], 1), _c("div", [_c("el-divider", {
    attrs: {
      "content-position": "left"
    }
  })], 1), _c("div", {
    staticStyle: {
      color: "#409EFF",
      "text-weight": "bold"
    }
  }, [_vm._v(" 充值配置： "), _c("el-button", {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      type: "success",
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.addPayMsg();
      }
    }
  }, [_vm._v(" 添加一行充值信息配置 ")])], 1), _c("div", _vm._l(_vm.form.role_list, function (item, index) {
    return _c("el-form-item", {
      key: index,
      attrs: {
        label: "选择服务器",
        "label-width": "150px"
      }
    }, [_c("div", {
      staticStyle: {
        display: "display: inline-block"
      }
    }, [_c("server-list", {
      staticStyle: {
        width: "180px !important",
        float: "left"
      },
      attrs: {
        readCacheType: 1,
        multiple: false,
        type: 1
      },
      model: {
        value: item.server_id,
        callback: function callback($$v) {
          _vm.$set(item, "server_id", $$v);
        },
        expression: "item.server_id"
      }
    }), _c("span", {
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_vm._v("角色ID")]), _c("el-input", {
      staticStyle: {
        width: "100px",
        "margin-left": "10px"
      },
      model: {
        value: item.role_id,
        callback: function callback($$v) {
          _vm.$set(item, "role_id", _vm._n($$v));
        },
        expression: "item.role_id"
      }
    }), _c("i", {
      staticClass: "el-icon-remove",
      staticStyle: {
        "font-size": "25px",
        "margin-left": "10px"
      },
      on: {
        click: function click($event) {
          return _vm.reducePayMsg(index);
        }
      }
    }), _c("span", {
      staticStyle: {
        float: "right"
      }
    })], 1)]);
  }), 1), _c("div", [_c("el-divider", {
    attrs: {
      "content-position": "left"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "选择充值",
      "label-width": "150px"
    }
  }, [_c("div", {
    staticStyle: {
      display: "display: inline-block"
    }
  }, [_c("pay-options", {
    staticStyle: {
      width: "180px",
      float: "left"
    },
    attrs: {
      type: 1,
      payArray: _vm.payArray
    },
    model: {
      value: _vm.form.pay_item_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pay_item_id", $$v);
      },
      expression: "form.pay_item_id"
    }
  })], 1)])], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "center"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.checkPay();
      }
    }
  }, [_vm._v("提交审核")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };